import { render, staticRenderFns } from "./UserOrdersList.vue?vue&type=template&id=f1b927b2&scoped=true&"
import script from "./UserOrdersList.vue?vue&type=script&lang=js&"
export * from "./UserOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./UserOrdersList.vue?vue&type=style&index=0&id=f1b927b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b927b2",
  null
  
)

export default component.exports